import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Profile } from 'src/app/models/fund-details.model'
import { AdobeLaunchService } from 'src/app/services/adobe-launch.service'
import { LogonService } from 'src/app/services/logon.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'td[VFA-buy-button]',
  templateUrl: './buy-button.component.html',
  styleUrls: ['./buy-button.component.scss'],
})
export class BuyButtonComponent implements OnInit {
  @Input() fundInput: Profile

  public vfeUrl = environment.vfeURLPrefix
  public vfaPersonal1Url = environment.vfaPersonal1Url
  public user = environment.UserLocation
  href: string
  public isLoggedOn: any
  finalURL: string

  constructor(
    public readonly logonService:LogonService,
    public adobeLaunchService: AdobeLaunchService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.getLogOnData()
    this.setBuyButtonURL()
  }

  // eslint-disable-next-line complexity, max-statements
  setBuyButtonURL(): void {
    if (
      this.fundInput.isETF &&
      !this.fundInput.fundFact.isClosed &&
      !this.fundInput.fundFact.isClosedToNewInvestors) {
      this.finalURL = `${this.vfeUrl}BuySellRouter?investmentType=EQUITY&nonRetirementMode=true&ticker=${this.fundInput.ticker}&transactionType=BUY`;
    } else if (
      this.fundInput.isMutualFund &&
      !this.fundInput.fundFact.isClosed &&
      !this.fundInput.fundFact.isClosedToNewInvestors) {
      this.finalURL = `${this.vfeUrl}BuySellRouter?investmentType=MUTL&nonRetirementMode=true&ticker=${this.fundInput.ticker}&transactionType=BUY`;
    }
  }

  buyButtonClicked(event: Event): void {
    event.preventDefault();
    this.adobeLaunchService.callToAction(
      'Buy',
      'Dynamic Funds List Page - Filter Output Section',
      'Button',
    )
    this.href = this.router.url ? this.router.url.substring(1) : ''
    if (
      !this.isLoggedOn
    ) {
      this.adobeLaunchService.touchPoint(this.href, 'Button', 'OOA', 'mmx')
    } else {
      this.adobeLaunchService.touchPoint(this.href, 'Button', 'buy', 'transact')
    }
    window.location.href = this.finalURL;
  }

  async getLogOnData() {
    try {
      const response = await this.logonService.getLoggedOn();
      this.isLoggedOn = Object.values(response)[1];
    } catch {
      this.isLoggedOn = false;
    }
  }

}
